var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12.26 24.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1.84 5.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1.41,
    width: 7.18,
    height: 10.47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-1.84 5.11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.42 1.23 9.73 12.55 22.57 11.32 21.26 0 8.42 1.23"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.17,3.59a5.46,5.46,0,0,1-5.47.54A4.6,4.6,0,0,1,2.84.31,4.82,4.82,0,0,1,6.19-4.22c1.87-.48,3.85.62,5,2.13A4.38,4.38,0,0,1,11,3.86c0,.05-.42.4-.22.48s.54-.15.69-.29A4.9,4.9,0,0,0,13.06-1.3,6,6,0,0,0,9-5C7-5.51,5-4.49,3.47-2.88a4.94,4.94,0,0,0-1.42,5A5.23,5.23,0,0,0,5.7,5.23,6.72,6.72,0,0,0,11.37,4c.1-.07.5-.36.4-.55s-.5.08-.6.15",
    transform: "translate(-1.84 5.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.07-1.53A2.62,2.62,0,0,0,9.18-.29c.07.18.84-.18.74-.45a2.32,2.32,0,0,1-.08-1.14c0-.17-.34-.05-.39,0s-.36.19-.38.37",
    transform: "translate(-1.84 5.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.11-1.48A1.6,1.6,0,0,0,5-.16c0,.15.83-.2.74-.44a1.34,1.34,0,0,1,.07-1.14c.08-.17-.18-.12-.26-.09a.86.86,0,0,0-.48.35",
    transform: "translate(-1.84 5.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.41,1.8a2.65,2.65,0,0,1-1.94,1A2.66,2.66,0,0,1,5.64,1.69c-.23-.28-1,.33-.83.57A2.89,2.89,0,0,0,7.23,3.52,4.41,4.41,0,0,0,9.88,2c.48-.49-.13-.58-.47-.24",
    transform: "translate(-1.84 5.11)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.46,17.15A3.15,3.15,0,0,0,8,17.77a7,7,0,0,0,2.66-5.08c.23-2.71-1.1-5.36-2.48-5.9C6.63,6.2,4.9,7.67,3.81,9.68,2.56,12,2.19,15.36,3.54,17.5c0,.07.33.51.15.63s-.43-.19-.55-.37a8.68,8.68,0,0,1-.91-7A7.4,7.4,0,0,1,5.85,5.86c1.76-.75,3.29.56,4.48,2.65a8.86,8.86,0,0,1,.84,6.5,6.24,6.24,0,0,1-3.26,4.2c-1.64.72-3.32.06-4.65-1.54-.08-.09-.39-.46-.29-.71s.41.1.49.19",
    transform: "translate(-1.84 5.11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.76,17.31a3.7,3.7,0,0,0,5,.1,6.8,6.8,0,0,0,2.38-5.36c0-2.72-1.76-5.2-3.33-5.58C8.09,6.05,6.36,7.72,5.36,9.84c-1.13,2.41-1.17,5.83.53,7.81.06.06.42.47.23.61s-.49-.14-.64-.3a8,8,0,0,1-1.73-6.88A7.54,7.54,0,0,1,7.21,5.81c1.84-.95,3.65.18,5.17,2.12A8.14,8.14,0,0,1,14,14.3a6.39,6.39,0,0,1-3.12,4.55c-1.72.91-3.62.44-5.25-1-.09-.08-.47-.41-.39-.67s.46.05.55.13",
    transform: "translate(-1.84 5.11)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bb1db5fb.svg";
export { ForwardRef as ReactComponent };